import React from "react";
import PropTypes from "prop-types";

import ListItem from "./ListItem";
import MuiListItemText from "@mui/material/ListItemText";

const ListItemText = (props) => {
  const {
    LeadComponent,
    TrailComponent,
    heading,
    description,
    variant,
    className,
    headingTypographyProps,
    descriptionTypographyProps,
    listItemTextVariant,
  } = props;

  const renderContentElement = () => (
    <MuiListItemText
      variant={listItemTextVariant}
      primary={heading}
      secondary={description}
      slotProps={{
        primary: headingTypographyProps,
        secondary: descriptionTypographyProps,
      }}
    />
  );

  return (
    <ListItem
      variant={variant}
      className={className}
      LeadComponent={LeadComponent}
      ContentComponent={renderContentElement()}
      TrailComponent={TrailComponent}
    />
  );
};

ListItemText.propTypes = {
  LeadComponent: PropTypes.element,
  TrailComponent: PropTypes.element,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  description: PropTypes.any,
  variant: PropTypes.string,
  className: PropTypes.string,
  headingTypographyProps: PropTypes.object,
  descriptionTypographyProps: PropTypes.object,
  listItemTextVariant: PropTypes.string,
};

export default ListItemText;
